import {
  adaptedToFraisAgences,
  fraisAgenceToAdapted,
  fraisAgencesToAdapted,
} from "../../adapter/fraisAgenceAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";

export const LOAD_SUCCESS_FRAIS_AGENCE = "LOAD_SUCCESS_FRAIS_AGENCE";
export const LOAD_FAIL_FRAIS_AGENCE = "LOAD_FAIL_FRAIS_AGENCE";
export const SAVE_SUCCESS_FRAIS_AGENCE = "SAVE_SUCCESS_FRAIS_AGENCE";
export const SAVE_FAIL_FRAIS_AGENCE = "SAVE_FAIL_FRAIS_AGENCE";
export const UPDATE_SUCCESS_FRAIS_AGENCE = "UPDATE_SUCCESS_FRAIS_AGENCE";
export const UPDATE_FAIL_FRAIS_AGENCE = "UPDATE_FAIL_FRAIS_AGENCE";
export const DELETE_SUCCESS_FRAIS_AGENCE = "DELETE_SUCCESS_FRAIS_AGENCE";
export const DELETE_FAIL_FRAIS_AGENCE = "DELETE_FAIL_FRAIS_AGENCE";

export function loadFraisAgences() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`fraisAgences`, HttpMethod.GET);

      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.frais_agence);
          dispatch({
            type: LOAD_SUCCESS_FRAIS_AGENCE,
            payload: fraisAgencesToAdapted(res.frais_agence),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_FRAIS_AGENCE,
            error: err,
          });
        });
    });
  };
}

export function saveFraisAgences(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`fraisAgences`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToFraisAgences(jsonData)) })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.frais_agence);
          dispatch({
            type: SAVE_SUCCESS_FRAIS_AGENCE,
            payload: fraisAgencesToAdapted(res.frais_agence),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: SAVE_FAIL_FRAIS_AGENCE,
            error: err,
          });
        });
    });
  };
}

export function updateFraisAgences(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`fraisAgences`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToFraisAgences(jsonData)) })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.frais_agence);
          dispatch({
            type: UPDATE_SUCCESS_FRAIS_AGENCE,
            payload: fraisAgencesToAdapted(res.frais_agence),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: UPDATE_FAIL_FRAIS_AGENCE,
            error: err,
          });
        });
    });
  };
}

export function deleteFraisAgences(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`fraisAgences/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.frais_agence);
          dispatch({
            type: DELETE_SUCCESS_FRAIS_AGENCE,
            payload: fraisAgenceToAdapted(res.frais_agence),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_FRAIS_AGENCE,
            payload: err,
          });
        });
    });
  };
}
